"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _renderprops = require("react-spring/renderprops");

var _styled = _interopRequireWildcard(require("../styled"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var SPACE = ' ';
var ENTER = 'Enter';
var INTERACTION_KEYS = [SPACE, ENTER];

var RippleContainer = _styled["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  user-select: none;\n  outline: none;\n  overflow: visible;\n  z-index: 2;\n"])));

var Ripple = (0, _styled["default"])(_renderprops.animated.span)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: block;\n  border-radius: 100%;\n  transform-origin: center;\n  position: absolute;\n\n  /* Prevents accidental highlighting/dragging */\n  pointer-events: none;\n  user-select: none;\n\n  /* Use GPU */\n  transform: scale3d(0, 0, 0);\n\n  ", "\n"])), function (props) {
  return (0, _styled.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    background-color: ", ";\n  "])), props.color || 'currentColor');
});
var focusAnimation = (0, _styled.keyframes)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  from {\n    transform: scale(0.5);\n  }\n\n  to {\n    transform: scale(0.7);\n  }\n"])));

var FocusRipple = _styled["default"].span(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: block;\n  border-radius: 100%;\n  transform-origin: center;\n  position: absolute;\n\n  /* Prevents accidental highlighting/dragging */\n  pointer-events: none;\n  user-select: none;\n\n  /* Use GPU */\n  transform: scale3d(0, 0, 0);\n  opacity: 0.2;\n\n  ", "\n\n  animation: ", " 500ms;\n  animation-iteration-count: infinite;\n  animation-direction: alternate;\n"])), function (props) {
  return (0, _styled.css)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    background-color: ", ";\n  "])), props.color);
}, focusAnimation);

var diagonalLength = function diagonalLength(a, b) {
  return Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));
};

var computeMiddleRippleDescriptionFromElement = function computeMiddleRippleDescriptionFromElement(element) {
  // @NOTE Should we maybe move this into the class and memoize it, too?
  var rect = element.getBoundingClientRect();
  var width = rect.width,
      height = rect.height;
  var x = width / 2;
  var y = height / 2;
  var radius = diagonalLength(x, y);
  return {
    x: x,
    y: y,
    radius: radius
  };
};
/**
 * This component serves as an easy drop-in component to indicate a component was interacted with. It's based on Material Design.
 *
 * The parent component must have `position: relative` for the positioning of ripples to work correclty, and `overflow: hidden` if you want
 * to prevent ripples bleeding out.
 *
 * You generally shouldn't need to use this component directly in the app. Using it for a new interactive component in the styleguide is fine, though.
 */
// TODO Convert to FC


var InteractionRipples = /*#__PURE__*/function (_React$Component) {
  _inherits(InteractionRipples, _React$Component);

  var _super = _createSuper(InteractionRipples);

  function InteractionRipples() {
    var _this;

    _classCallCheck(this, InteractionRipples);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "pointerUsed", false);

    _defineProperty(_assertThisInitialized(_this), "state", {
      ripples: [],
      focusRipple: null
    });

    _defineProperty(_assertThisInitialized(_this), "handlePointerDown", function (event) {
      _this.pointerUsed = true;
      var element = event.currentTarget;
      var centered = _this.props.centered; // @NOTE Should we maybe memoize this?

      var rect = element.getBoundingClientRect();
      var width = rect.width,
          height = rect.height;
      var x = 0;
      var y = 0;
      var radius = 0;

      if (centered) {
        x = width / 2;
        y = height / 2;
        radius = diagonalLength(x, y);
      } else {
        x = event.clientX - rect.left;
        y = event.clientY - rect.top;
        radius = Math.max(diagonalLength(x, y), // ┌ top left
        diagonalLength(width - x, y), // ┐ top right
        diagonalLength(width - x, height - y), // ┘ botom right
        diagonalLength(x, height - y) // └ bottom left
        );
      }

      _this.addRipple(x, y, radius);
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyPress", function (event) {
      // Only handle Click and space clicks
      if (!INTERACTION_KEYS.includes(event.key)) return;
      _this.pointerUsed = false;

      var _computeMiddleRippleD = computeMiddleRippleDescriptionFromElement(event.currentTarget),
          x = _computeMiddleRippleD.x,
          y = _computeMiddleRippleD.y,
          radius = _computeMiddleRippleD.radius;

      _this.addRipple(x, y, radius);

      setTimeout(function () {
        return _this.removeRipple();
      }, 50);

      _this.setState({
        focusRipple: {
          x: x,
          y: y,
          radius: radius,
          key: 0
        }
      }); // Disable the built in scroll behaviour browsers do when space is pressed


      if (event.key === SPACE) event.preventDefault();
    });

    _defineProperty(_assertThisInitialized(_this), "handleFocus", function (event) {
      if (_this.pointerUsed) return;

      var _computeMiddleRippleD2 = computeMiddleRippleDescriptionFromElement(event.currentTarget),
          x = _computeMiddleRippleD2.x,
          y = _computeMiddleRippleD2.y,
          radius = _computeMiddleRippleD2.radius;

      _this.setState({
        focusRipple: {
          x: x,
          y: y,
          radius: radius,
          key: 0
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "makeFocusRipple", function () {
      var focusRipple = _this.state.focusRipple;
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          rippleColor = _this$props.rippleColor;
      if (!focusRipple) return null;
      if (disabled) return;
      return /*#__PURE__*/React.createElement(FocusRipple, {
        draggable: false,
        color: rippleColor,
        style: {
          left: focusRipple.x - focusRipple.radius,
          top: focusRipple.y - focusRipple.radius,
          width: focusRipple.radius * 2,
          height: focusRipple.radius * 2
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleBlur", function () {
      _this.setState({
        focusRipple: null
      });
    });

    _defineProperty(_assertThisInitialized(_this), "addRipple", function (x, y, radius) {
      if (_this.props.disabled) return;
      var offset = _this.props.offset;

      _this.setState(function (state) {
        return {
          ripples: state.ripples.concat({
            x: x,
            y: y,
            radius: radius - offset,
            key: Date.now()
          })
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "removeRipple", function () {
      if (_this.props.disabled) return;

      _this.setState(function (state) {
        var newRipples = state.ripples.slice(0, -1);
        return {
          ripples: newRipples
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handlePointerUp", function () {
      _this.removeRipple();

      _this.setState({
        focusRipple: null
      });
    });

    _defineProperty(_assertThisInitialized(_this), "computeFrom", function (_ref) {
      var x = _ref.x,
          y = _ref.y,
          radius = _ref.radius;
      var left = x - radius;
      var top = y - radius;
      return {
        left: left,
        top: top,
        width: radius * 2,
        height: radius * 2,
        opacity: 0.8,
        transform: 'scale(0)'
      };
    });

    return _this;
  }

  _createClass(InteractionRipples, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          rippleColor = _this$props2.rippleColor,
          focusable = _this$props2.focusable;
      var ripples = this.state.ripples;
      var focusRipple = this.makeFocusRipple();
      return /*#__PURE__*/React.createElement(RippleContainer // @NOTE Prevents a situation where the drag event would sometimes trigger
      //       which for some reason leads to the onPointerUp/onPointerLeave
      //       events not triggering. Added this prop on `Ripple`, too.
      //       I wonder if this is a browser oddity, or a bug in our code?
      , {
        draggable: false,
        tabIndex: focusable ? 0 : undefined,
        onKeyPress: this.handleKeyPress,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onPointerDown: this.handlePointerDown,
        onPointerUp: this.handlePointerUp,
        onPointerLeave: this.removeRipple
      }, focusRipple, /*#__PURE__*/React.createElement(_renderprops.Transition, {
        "native": true,
        config: {
          tension: 260,
          friction: 40
        },
        items: ripples,
        keys: function keys(ripple) {
          return ripple.key;
        },
        from: this.computeFrom,
        enter: {
          opacity: 0.2,
          transform: 'scale(1)'
        },
        leave: {
          opacity: 0.0,
          transform: 'scale(1)'
        }
      }, function (_ripple) {
        return function (props) {
          return /*#__PURE__*/React.createElement(Ripple, {
            draggable: false,
            style: props,
            color: rippleColor
          });
        };
      }));
    }
  }]);

  return InteractionRipples;
}(React.Component);

_defineProperty(InteractionRipples, "defaultProps", {
  rippleColor: 'currentColor',
  config: {
    tension: 260,
    friction: 40
  },
  offset: 0
});

var _default = InteractionRipples;
exports["default"] = _default;